import { BiBox, BiCar } from 'react-icons/bi'

import { Delivery } from '@/store/useCakeMaker'
import { formatMoney } from '@/utils'

import './styles.scss'

type DeliveryTaxProps = {
  delivery: Delivery | undefined
  calculating: boolean
  onRemove: () => void
}

export function DeliveryTax({
  delivery,
  calculating,
  onRemove,
}: DeliveryTaxProps) {
  const number = delivery?.number ? `, ${delivery.number}` : ''
  const mainInfo = `${delivery?.address}${number} - ${delivery?.neighborhood}`
  const subInfo = `${delivery?.city} - ${delivery?.state}, ${delivery?.zipCode}`

  return (
    <div className="delivery-tax-wrapper" role="status" aria-live="polite">
      <div className="delivery-tax-loading" data-visible={calculating}>
        <div className="delivery-tax-loading__shimmer">
          <BiBox className="delivery-tax-loading__shimmer__icon" />
          <span className="delivery-tax-loading__shimmer__text">
            Calculando o frete...
          </span>
        </div>
      </div>

      <div className="delivery-tax" data-visible={!!delivery?.address}>
        <div className="delivery-tax__content">
          <BiCar className="delivery-tax__content__icon" aria-hidden />
          <div className="delivery-tax__content__address">
            <p className="delivery-tax__content__address__main">{mainInfo}</p>
            <p className="delivery-tax__content__address__sub">{subInfo}</p>
            <p className="delivery-tax__content__address__price">
              Por {formatMoney(delivery?.price ?? 0)}
            </p>
          </div>
        </div>

        <button
          type="button"
          className="delivery-tax__remove"
          onClick={onRemove}
          aria-label="Remover endereço de entrega"
        >
          <p>Remover endereço</p>
        </button>
      </div>
    </div>
  )
}
